import { FormControlLabel, Grid, Stack, Switch } from "@mui/material";
import { getDefaultTaskPeriodStr } from "../../page/TaskPage/utils";
import { MINUTES_TO_MILLISECONDS } from "../../helpers/constants";

export function AllDayTodoSwitches({
    isAllDay,
    setIsAllDay,
    isTodo,
    setIsTodo,
    setValue,
    disabled = false,
    t,
}) {
    const today = new Date()
    const formattedDate = new Date(
        today.getTime() - today.getTimezoneOffset() * MINUTES_TO_MILLISECONDS,
    )
        .toISOString()
        .split("T")[0];

    return (
        <Grid item xs={12}>
            <Stack direction="row" spacing={2} justifyContent="center">
                <FormControlLabel
                    control={
                        <Switch
                            checked={isAllDay}
                            onChange={(e) => {
                                setIsAllDay(e.target.checked);
                                if (e.target.checked) {
                                    setValue("startTime", "");
                                    setValue("stopTime", "");
                                    setValue("date", formattedDate)
                                    setIsTodo(false);
                                } else {
                                    setValue("startTime", getDefaultTaskPeriodStr().start);
                                    setValue("stopTime", getDefaultTaskPeriodStr().end);
                                    setValue("date", formattedDate)
                                }
                            }}
                        />
                    }
                    disabled={disabled}
                    label={t("tasks.addTaskDialog.isAllDay")}
                />
                <FormControlLabel
                    control={
                        <Switch
                            checked={isTodo}
                            onChange={(e) => {
                                setIsTodo(e.target.checked);
                                if (e.target.checked) {
                                    setValue("date", "");
                                    setValue("startTime", "");
                                    setValue("stopTime", "");
                                    setIsAllDay(false);
                                }
                                else {
                                    setValue("startTime", getDefaultTaskPeriodStr().start);
                                    setValue("stopTime", getDefaultTaskPeriodStr().end);
                                    setValue("date", formattedDate)
                                }
                            }}
                        />
                    }
                    disabled={disabled}
                    label={t("tasks.addTaskDialog.isTodo")}
                />
            </Stack>
        </Grid>
    );
}
